import type { paths } from '@/api/typeApi'
import createClient from 'openapi-fetch'

import { BEAM_ENDPOINT } from '@/constants/api'
import { authMiddleware } from './authMiddleware'

export const client = createClient<paths>({
  baseUrl: BEAM_ENDPOINT,
})

client.use(authMiddleware)

export default client
